import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ModalTitle } from "src/components/Modals/Components/ModalsComponents";
import EditIcon from "src/images/Icons/newIcons/exam/more/edit.svg";
import newApi from "src/newApi";

import { DescriptionArea } from "../Filters/FlashcardsFilters/PermissionFilter";
import DefaultModal from "./DefaultModal";

export default function ReportErrorInArticleModal(props) {
	const { t } = useTranslation();
	const [values, setValues] = useState({ stipulation: "", sourceInfo: "" });

	const report = async () => {
		try {
			await newApi.reportArticle(props.row.deprecatedArticleId, {
				section: props.row.title,
				...values,
			});
			toast.success(t("modals.reportError.success"), {
				position: toast.POSITION.BOTTOM_RIGHT,
				pauseOnHover: false,
				autoClose: 2000,
			});
			props.onClose();
		} catch {
			toast.error(t("errors.somethingWentWrong"), {
				position: toast.POSITION.BOTTOM_RIGHT,
				pauseOnHover: false,
				autoClose: 2000,
			});
		}
	};

	return (
		<DefaultModal
			onClose={props.onClose}
			primaryText={t("modals.reportError.primary")}
			onPrimaryClick={() => report()}
			secondaryText={t("commands.cancel")}
			onSecondaryClick={props.onClose}
			fullWidth
		>
			<ModalTitle Icon={EditIcon} title={t("modals.reportError.header")} />
			<div className="flex items-center justify-center flex-col w-100 gap-12">
				<p>{t("modals.reportError.subheader")}</p>
				<DescriptionArea
					className="w-100"
					label={t("modals.reportError.stipulation")}
					description={values.stipulation}
					setDescription={(stipulation) =>
						setValues({ ...values, stipulation })
					}
				/>
				<DescriptionArea
					className="w-100"
					label={t("modals.reportError.sourceInfo")}
					description={values.sourceInfo}
					setDescription={(sourceInfo) => setValues({ ...values, sourceInfo })}
				/>
			</div>
		</DefaultModal>
	);
}
